// @flow strict

import { Spin } from 'antd';
import { useEffect, useState } from 'react';
import { getAllReferRules } from '../../../api/refer';
import RuleCard from './RuleCard';

function RedeemRules({ point, userInfo }) {
  const [referRules, setReferRules] = useState([]);
  const [fetching, setFetching] = useState(false);

  const fetchRedeemRules = async () => {
    setFetching(true);

    try {
      const res = await getAllReferRules();

      if (res?.data?.referRules) {
        console.log(res?.data?.referRules);
        setReferRules(res.data.referRules);
      };
    } catch (error) {
      console.log(error);
    } finally {
      setFetching(false);
    };
  };

  useEffect(() => {
    fetchRedeemRules();
  }, []);

  return (
    <Spin spinning={fetching} tip="Loading..." className="w-100">
      <div className="d-flex flex-column gap-3">
        {
          referRules?.length > 0 && referRules.map((rule, index) => (
            <RuleCard
              userInfo={userInfo}
              point={point}
              key={index}
              rule={rule}
            />
          ))
        }
      </div>
    </Spin>
  );
};

export default RedeemRules;